import { render } from "./TransferConfirmModal.vue?vue&type=template&id=5d960b28&scoped=true"
import script from "./TransferConfirmModal.vue?vue&type=script&lang=js"
export * from "./TransferConfirmModal.vue?vue&type=script&lang=js"

import "./TransferConfirmModal.vue?vue&type=style&index=0&id=5d960b28&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d960b28"]])

export default __exports__